import React, { useState } from "react";
import { X, Sparkles } from "lucide-react";
import { PRICES } from "../../lib/stripe-config";

type UpgradeReason = "task_limit" | "general";

interface UpgradeDialogProps {
  reason: UpgradeReason;
  onClose: () => void;
  onCheckout: (priceId: string) => Promise<void>;
}

const UpgradeDialog: React.FC<UpgradeDialogProps> = ({
  onClose,
  onCheckout,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleCheckout = async () => {
    if (!PRICES.monthly.id) return;
    setIsLoading(true);
    try {
      await onCheckout(PRICES.monthly.id);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-2 sm:p-4 animate-dialog-backdrop"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-label="Subscribe to JuDI"
        className="bg-warm-bg-card rounded-card border border-warm-border p-4 sm:p-6 w-full max-w-lg shadow-soft-md animate-dialog-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-2 mb-4">
          <div>
            <h2 className="font-heading text-lg text-warm-text-primary">
              JuDI is ${PRICES.monthly.amount} a month
            </h2>
            <p className="text-sm text-warm-text-secondary">
              1 month free, then $5 a month. Your card is saved when you start.
            </p>
          </div>
          <button
            onClick={onClose}
            aria-label="Close subscribe dialog"
            className="text-warm-text-secondary hover:text-warm-text-primary transition-colors p-1 -m-1 flex-shrink-0"
          >
            <X size={20} />
          </button>
        </div>
        <button
          onClick={handleCheckout}
          disabled={isLoading}
          className="w-full py-3 px-4 bg-warm-blue hover:bg-warm-blue-dark disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded-soft transition-colors flex items-center justify-center gap-2"
        >
          {isLoading ? (
            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            <>
              <Sparkles size={18} />
              Start 1 month free
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default UpgradeDialog;
